export const GET_ABOUT_MICROSERVICE = "GET_ABOUT_MICROSERVICE";
export const GET_ABOUT_MICROSERVICE_SUCCESS = "GET_ABOUT_MICROSERVICE_SUCCESS";
export const GET_ABOUT_MICROSERVICE_ERROR = "GET_ABOUT_MICROSERVICE_ERROR";

export const GET_ABOUT_MICROSERVICES = "GET_ABOUT_MICROSERVICES";
export const GET_ABOUT_MICROSERVICES_SUCCESS =
  "GET_ABOUT_MICROSERVICES_SUCCESS";
export const GET_ABOUT_MICROSERVICES_ERROR = "GET_ABOUT_MICROSERVICES_ERROR";

export const ADD_ABOUT_MICROSERVICE = "ADD_ABOUT_MICROSERVICE";
export const ADD_ABOUT_MICROSERVICE_SUCCESS = "ADD_ABOUT_MICROSERVICE_SUCCESS";
export const ADD_ABOUT_MICROSERVICE_ERROR = "ADD_ABOUT_MICROSERVICE_ERROR";

export const MODIFY_ABOUT_MICROSERVICE = "MODIFY_ABOUT_MICROSERVICE";
export const MODIFY_ABOUT_MICROSERVICE_SUCCESS =
  "MODIFY_ABOUT_MICROSERVICE_SUCCESS";
export const MODIFY_ABOUT_MICROSERVICE_ERROR =
  "MODIFY_ABOUT_MICROSERVICE_ERROR";

export const DELETE_ABOUT_MICROSERVICE = "DELETE_ABOUT_MICROSERVICE";
export const DELETE_ABOUT_MICROSERVICE_SUCCESS =
  "DELETE_ABOUT_MICROSERVICE_SUCCESS";
export const DELETE_ABOUT_MICROSERVICE_ERROR =
  "DELETE_ABOUT_MICROSERVICE_ERROR";
